export function useMaxCharsForClientContext() {
    return 55_000;
}
//# sourceMappingURL=useMaxCharsForClientContext.js.map